import React, { FunctionComponent, useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { UserStore } from '../../core/user-store';
import HomepageCarousel from './homepage-carousel';
import nexarLogoUrl from '../../assets/images/nexar-primary-lockup-white-rgb-100-px.png';
import { track, TrackedEvent } from '../../core/analytics';
import HomepageLinks from './homepage-links';
import './HomePage.scss';

interface Props {}

const HomePage: FunctionComponent<Props> = () => {
  const { userStore } = useContext(MobXProviderContext);
  const { userData } = userStore as UserStore;
  return (
    <React.Fragment>
      <section className="homepage-hero">
        <div className="hero-header">
          <HomepageCarousel />
        </div>
      </section>
      <section className="homepage-clients">
        <p className="title">Powered by Nexar</p>
        <p>Bring your integrations and applications to the speed of life with Nexar’s Developers Portal</p>
      </section>
      <section className="homepage-links">
        <HomepageLinks />
      </section>
      {/*
      <section className="homepage-copyright container">
        <img className="logo" src={nexarLogoUrl} alt="Nexar" draggable={false} />
        <div>© 2023, Nexar All Rights Reserved</div>
      </section>
      */}
    </React.Fragment>
  );
};

export default HomePage;
